/* Artiqtone theme.js — cart, product gallery, AI chat, drawers */
(function () {
  const $ = (s, root) => (root || document).querySelector(s);
  const $$ = (s, root) => Array.from((root || document).querySelectorAll(s));
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(window.Shopify?.locale || 'en-IN', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(0); }
  };

  /* ---------- Mobile nav ---------- */
  const mobileToggle = $('[data-mobile-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    const setOpen = (open) => {
      mobileNav.classList.toggle('is-open', open);
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    mobileToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      setOpen(!mobileNav.classList.contains('is-open'));
    });
    mobileNav.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('click', (e) => {
      if (mobileNav.classList.contains('is-open') && !mobileNav.contains(e.target) && !mobileToggle.contains(e.target)) {
        setOpen(false);
      }
    });
    window.addEventListener('resize', () => { if (window.innerWidth >= 900) setOpen(false); });
  }

  /* ---------- Review form: honeypot + basic timing guard against simple bots ---------- */
  const reviewForm = $('#ReviewForm');
  if (reviewForm) {
    const loadedAt = Date.now();
    reviewForm.addEventListener('submit', (e) => {
      const hp = reviewForm.querySelector('input[name="contact[Website]"]');
      const tooFast = Date.now() - loadedAt < 2500;
      if ((hp && hp.value.trim() !== '') || tooFast) {
        e.preventDefault();
        const btn = reviewForm.querySelector('[data-review-submit]');
        if (btn) { btn.textContent = 'Please try again'; }
        return;
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const openDrawer = () => { drawer?.classList.add('is-open'); document.body.style.overflow = 'hidden'; renderCart(); };
  const closeDrawer = () => { drawer?.classList.remove('is-open'); document.body.style.overflow = ''; };

  $$('[data-open-cart]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  drawer?.addEventListener('click', (e) => { if (e.target.closest('[data-close-cart], .backdrop')) closeDrawer(); });

  /* When the shopper heads into checkout (Razorpay Magic overlay) from the
     drawer, close the drawer and release our body scroll lock behind the
     overlay — otherwise the page can come back frozen (unable to scroll)
     after they exit the checkout modal. */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-checkout]')) {
      setTimeout(closeDrawer, 400);
    }
  });

  /* Safety nets against a stuck scroll lock:
     1. bfcache restores (back button from checkout) can revive a locked page.
     2. If any third-party overlay leaves body overflow hidden while our
        drawer is closed and no Razorpay iframe is visible, release it. */
  window.addEventListener('pageshow', () => {
    if (drawer && !drawer.classList.contains('is-open')) document.body.style.overflow = '';
  });
  setInterval(() => {
    if (document.body.style.overflow === 'hidden' && drawer && !drawer.classList.contains('is-open')) {
      const rzp = document.querySelector('iframe[src*="razorpay"]');
      const rzpVisible = rzp && rzp.offsetWidth > 0 && rzp.offsetHeight > 0 && getComputedStyle(rzp).display !== 'none' && getComputedStyle(rzp).visibility !== 'hidden';
      if (!rzpVisible) document.body.style.overflow = '';
    }
  }, 1500);

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function renderCart() {
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    const countEls = $$('[data-cart-count]');
    if (!body || !foot) return;
    body.innerHTML = '<div class="muted" style="font-size:13px">Loading…</div>';
    fetchCart().then((cart) => {
      countEls.forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="muted" style="font-size:13px;text-align:center;margin-top:40px" data-testid="cart-empty">Your cart is empty.</div>';
        foot.innerHTML = '';
        return;
      }
      body.innerHTML = cart.items.map((it) => `
        <div class="cart-line" data-line-key="${it.key}">
          <img src="${it.image || ''}" alt="">
          <div class="info">
            <div class="name">${it.product_title}</div>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="variant">${it.variant_title}</div>` : ''}
            <div class="row">
              <div class="qty">
                <button data-cart-qty="dec" aria-label="decrease">−</button>
                <input type="number" min="1" value="${it.quantity}" data-cart-qty-input>
                <button data-cart-qty="inc" aria-label="increase">+</button>
              </div>
              <span class="muted" style="font-size:12px">${money(it.final_line_price)}</span>
              <button class="remove" data-cart-remove aria-label="remove">✕</button>
            </div>
          </div>
        </div>
      `).join('');

      const threshold = parseInt(window.__theme?.freeShippingThreshold || '0', 10) * 100;
      const remaining = threshold - cart.total_price;
      const shipHint = threshold && remaining > 0
        ? `Add ${money(remaining)} more for free shipping.`
        : (threshold ? 'You qualified for free shipping.' : '');
      foot.innerHTML = `
        <div class="subtotal-row"><span class="muted">Subtotal</span><span class="price" data-cart-subtotal>${money(cart.total_price)}</span></div>
        ${shipHint ? `<div class="free-shipping-hint">${shipHint}</div>` : ''}
        <a href="/checkout" class="btn btn-primary" style="width:100%;height:48px" data-cart-checkout>Checkout</a>
        <a href="/cart" class="btn btn-outline" style="width:100%;height:40px;margin-top:8px" data-cart-view>View cart</a>
      `;
    }).catch(() => { body.innerHTML = '<div class="error">Failed to load cart.</div>'; });
  }

  drawer?.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const key = line.dataset.lineKey;
    const input = $('[data-cart-qty-input]', line);
    let qty = parseInt(input.value, 10) || 1;
    if (e.target.matches('[data-cart-qty="inc"]')) qty += 1;
    else if (e.target.matches('[data-cart-qty="dec"]')) qty = Math.max(0, qty - 1);
    else if (e.target.matches('[data-cart-remove]')) qty = 0;
    else return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    renderCart();
  });

  /* ---------- Place Your Custom Order (WhatsApp) for sold-out products + general contact ---------- */
  function whatsappUrl(message) {
    const raw = (window.__theme && window.__theme.whatsapp) || '';
    const num = raw.replace(/\D/g, '');
    if (!num) return null;
    return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
  }

  document.addEventListener('click', (e) => {
    const cta = e.target.closest('[data-whatsapp-cta]');
    if (!cta) return;
    e.preventDefault();
    e.stopPropagation();
    const custom = cta.dataset.whatsappMessage;
    const title = cta.dataset.productTitle;
    const message = custom || (title ? `Hi, I'd like to order: ${title}` : "Hi, I have a question about your products.");
    const url = whatsappUrl(message);
    if (url) window.open(url, '_blank');
  });

  /* ---------- Add to cart (all product forms). ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-atc-btn]');

    if (btn && btn.dataset.available === 'false') {
      const title = document.querySelector('[data-testid="pdp-title"]')?.textContent?.trim() || document.title;
      const url = whatsappUrl(`Hi, I'd like to order: ${title}`);
      if (url) window.open(url, '_blank');
      return;
    }

    const originalText = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const fd = new FormData(form);
      fd.set('sections', 'header');
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('add failed');
      openDrawer();
    } catch (err) {
      alert('Sorry, this item could not be added to cart.');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = originalText || 'Add to cart'; }
    }
  });

  fetchCart().then((cart) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }).catch(() => {});

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', (e) => {
    const thumbBtn = e.target.closest('[data-pdp-thumb]');
    if (!thumbBtn) return;
    const scope = thumbBtn.closest('.pdp-thumbs') || document;
    const main = $('[data-pdp-main]');
    if (main) main.src = thumbBtn.dataset.pdpThumb;
    $$('[data-pdp-thumb]', scope).forEach((b) => b.classList.remove('is-active'));
    thumbBtn.classList.add('is-active');
  });

  /* ---------- PDP qty ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const wrap = btn.closest('.qty-picker');
    const input = wrap ? wrap.querySelector('[data-qty-input]') : $('[data-qty-input]');
    if (!input) return;
    let v = parseInt(input.value, 10) || 1;
    v = btn.dataset.qtyBtn === 'inc' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  /* ---------- PDP high-variant option picker ---------- */
  document.addEventListener('click', async (e) => {
    const chip = e.target.closest('[data-main-product] .chip');
    if (!chip || chip.classList.contains('is-active')) return;
    const root = chip.closest('[data-main-product]');
    const wrap = chip.closest('[data-option-selector]');
    if (!root || !wrap) return;

    $$('.chip', wrap).forEach((c) => c.classList.remove('is-active'));
    chip.classList.add('is-active');
    wrap.dataset.currentValueId = chip.dataset.optionValueId;

    const ids = $$('[data-option-selector]', root)
      .map((w) => w.dataset.currentValueId)
      .filter(Boolean);
    if (!ids.length) return;

    root.classList.add('is-loading');
    try {
      const url = `${root.dataset.productUrl}?option_values=${ids.join(',')}&section_id=${root.dataset.sectionId}`;
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('section refresh failed');
      const html = await res.text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-main-product]');
      if (next) {
        root.replaceWith(next);
      } else {
        root.classList.remove('is-loading');
      }
    } catch (err) {
      root.classList.remove('is-loading');
    }
  });

  /* ---------- Testimonials carousel ---------- */
  $$('[data-testimonial-track]').forEach((track) => {
    const section = track.closest('.testimonials-section');
    const cards = $$('.testimonial-card', track);
    const dotsWrap = section?.querySelector('[data-testimonial-dots]');
    const dots = dotsWrap ? $$('.testimonial-dot', dotsWrap) : [];
    const prevBtn = section?.querySelector('[data-testimonial-prev]');
    const nextBtn = section?.querySelector('[data-testimonial-next]');

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const i = cards.indexOf(entry.target);
          setTimeout(() => entry.target.classList.add('is-visible'), Math.max(i, 0) * 60);
          io.unobserve(entry.target);
        });
      }, { threshold: 0.2 });
      cards.forEach((c) => io.observe(c));
    } else {
      cards.forEach((c) => c.classList.add('is-visible'));
    }

    const step = () => (cards[0]?.getBoundingClientRect().width || 320) + 20;

    const updateNav = () => {
      const max = track.scrollWidth - track.clientWidth - 4;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = max <= 4 || track.scrollLeft >= max;
      if (dots.length) {
        const idx = Math.min(dots.length - 1, Math.round(track.scrollLeft / step()));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
    };

    prevBtn?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    nextBtn?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' })));

    let rafPending = false;
    track.addEventListener('scroll', () => {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(() => { updateNav(); rafPending = false; });
    }, { passive: true });
    updateNav();
    window.addEventListener('resize', updateNav);

    let isDown = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      isDown = true; moved = false;
      startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') track.scrollBy({ left: step(), behavior: 'smooth' });
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    const canHover = window.matchMedia('(hover: hover)').matches;
    if (!canHover) {
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (moved) return;
          const alreadyActive = card.classList.contains('is-active');
          cards.forEach((c) => c.classList.remove('is-active'));
          if (!alreadyActive) { e.preventDefault(); card.classList.add('is-active'); }
        });
      });
    }
  });

  /* ---------- AI chat widget ----------
     Rules-based scenario/keyword matcher over the live product catalog
     (window.__theme.catalog, populated in header.liquid). Deliberately NOT
     calling an external LLM or Shopify's search/recommendations endpoints:
     no network dependency, no API keys to leak, no rate limits, no price-unit
     bugs — and for a 3-product catalog, a well-built scenario list covers
     real customer phrasing at least as well as a general-purpose model would,
     with zero risk of the widget going down. ACOUSTIC_KB maps each product to
     every symptom / room-type / synonym a shopper might type, not just literal
     catalog words, so "gaming room echo" or "my podcast room sounds bad"
     resolve correctly even though those words don't appear in any title. */
  const fab = $('[data-chat-fab]');
  const panel = $('[data-chat-panel]');
  const chatBody = $('[data-chat-body]');
  const chatInput = $('[data-chat-input]');
  const chatSend = $('[data-chat-send]');
  const chatClose = $('[data-chat-close]');
  const openChat = () => { panel?.classList.remove('hidden'); fab?.classList.add('hidden'); };
  const closeChat = () => { panel?.classList.add('hidden'); fab?.classList.remove('hidden'); };
  fab?.addEventListener('click', openChat);
  chatClose?.addEventListener('click', closeChat);

  function addMsg(role, html) {
    if (!chatBody) return;
    const div = document.createElement('div');
    div.className = 'chat-msg ' + role;
    div.innerHTML = html;
    chatBody.appendChild(div);
    chatBody.scrollTop = chatBody.scrollHeight;
  }

  const ACOUSTIC_KB = {
    'rockwool-acoustic-panels': [
      'panel', 'panels', 'acoustic panel', 'acoustic treatment', 'absorption', 'absorb', 'absorbing',
      'echo', 'echoing', 'echoes', 'echoey', 'echoy', 'reverb', 'reverberation', 'reverberating', 'reflection', 'reflections',
      'hollow', 'boomy room', 'harsh sound', 'too much echo', 'sounds echoey', 'voice echoes', 'call echo', 'zoom echo',
      'teams call', 'meeting room', 'conference room', 'podcast', 'podcasting', 'vocal booth', 'recording booth',
      'home studio', 'recording studio', 'mixing room', 'studio room', 'vlogging', 'streaming room', 'stream setup',
      'gaming room', 'youtube room', 'content room', 'office acoustics', 'classroom noise', 'restaurant noise',
      'cafe noise', 'gym echo', 'yoga studio', 'dance studio', 'church acoustics', 'auditorium', 'hall echo',
      'living room echo', 'bedroom studio', 'wall treatment', 'sound treatment', 'treat my room', 'treat a room',
      'improve room sound', 'wall panel', 'ceiling cloud', 'home theater', 'home theatre', 'cinema room', 'clarity',
      'dialogue clarity', 'speech clarity', 'noisy room', 'loud room', 'muffled call', 'echo chamber',
      'sound bounce', 'bouncy sound', 'tinny sound', 'harsh room sound', 'recording sounds bad', 'mic picks up room',
      'video call sounds bad', 'coworking space noise', 'therapy room', 'consultation room', 'library noise'
    ],
    'wooden-sound-diffusers-skyline': [
      'diffuser', 'diffusers', 'diffusion', 'flutter echo', 'harsh reflection', 'sounds too dead', 'over damped',
      'overdamped', 'dry sound', 'lifeless room', 'dead room', 'control room', 'listening room', 'stereo imaging',
      'mastering room', 'natural ambience', 'live room', 'band room', 'rehearsal room', 'practice room', 'music room',
      'wood panel', 'decorative acoustic', 'scatter sound', 'sound scatter', 'too much foam', 'sounds unnatural',
      'want natural sound', 'room sounds artificial'
    ],
    'sub-woofer-isolation-stands': [
      'subwoofer', 'sub woofer', 'sub-woofer', 'bass rumble', 'boomy bass', 'muddy bass', 'vibration', 'vibrating floor',
      'shaking floor', 'floor noise', 'neighbours downstairs', 'neighbors downstairs', 'speaker stand',
      'monitor stand', 'isolation stand', 'decouple', 'resonance', 'speaker shaking', 'floor vibration',
      'studio monitor', 'bass bleed', 'subwoofer noise', 'speaker rattle', 'speakers rattling', 'bass through floor'
    ]
  };

  const SOUNDPROOF_KEYWORDS = [
    'soundproof', 'sound proof', 'sound proofing', 'block noise', 'stop noise from outside',
    'neighbours hear', 'neighbors hear', 'hear through the wall', 'hear through wall', 'sound leaking',
    'sound isolation', 'isolate the room', 'noise from outside', 'traffic noise', 'street noise',
    'sound coming through the wall', 'wall insulation', 'block sound from', 'keep sound in the room',
    'keep sound from leaving'
  ];

  const GREETING_WORDS = ['hi', 'hello', 'hey', 'yo', 'sup', 'good morning', 'good afternoon', 'good evening'];

  function scoreProduct(text, keywords) {
    let score = 0;
    for (const kw of keywords) {
      if (text.includes(kw)) score += kw.includes(' ') ? 2 : 1;
    }
    return score;
  }

  function findMatches(lowerText) {
    const scored = Object.keys(ACOUSTIC_KB)
      .map((handle) => ({ handle, score: scoreProduct(lowerText, ACOUSTIC_KB[handle]) }))
      .filter((r) => r.score > 0)
      .sort((a, b) => b.score - a.score);
    return scored.slice(0, 2).map((r) => r.handle);
  }

  function catalogFor(handle) {
    const list = (window.__theme && window.__theme.catalog) || [];
    return list.find((p) => p.handle === handle) || null;
  }

  function chatWhatsappButton(promptText) {
    const wa = window.__theme?.whatsapp;
    if (!wa) return;
    const btn = document.createElement('button');
    btn.className = 'chat-whatsapp';
    btn.innerHTML = '💬  Continue on WhatsApp';
    btn.addEventListener('click', () => {
      const msg = `Hi Artiqtone team, I asked your site assistant: \"${promptText}\" and wanted more help.`;
      window.open(`https://wa.me/${wa.replace(/\D/g, '')}?text=${encodeURIComponent(msg)}`, '_blank');
    });
    chatBody.appendChild(btn);
    chatBody.scrollTop = chatBody.scrollHeight;
  }

  function sendChat() {
    const text = (chatInput?.value || '').trim();
    if (!text) return;
    addMsg('user', escapeHtml(text));
    chatInput.value = '';

    const lower = ' ' + text.toLowerCase() + ' ';

    if (GREETING_WORDS.some((g) => lower.trim() === g || lower.includes(' ' + g + ' ') || lower.trim().startsWith(g + ' ') || lower.trim().startsWith(g + ','))) {
      addMsg('assistant', "Hi! Tell me about the room or problem you're dealing with — things like echo, an echoey podcast room, a boomy subwoofer, or a home studio that sounds too dead — and I'll point you to the right product.");
      return;
    }

    const isSoundproofing = SOUNDPROOF_KEYWORDS.some((kw) => lower.includes(kw));
    const matches = findMatches(lower);

    if (matches.length) {
      const items = matches.map((handle) => {
        const p = catalogFor(handle);
        if (!p) return '';
        const priceHtml = typeof p.price === 'number' ? ` — <span class=\"muted\">${money(p.price)}</span>` : '';
        const availHtml = p.available ? '' : ' <span class=\"muted\">(custom order — call to order)</span>';
        return `<li><a href=\"${p.url}\" style=\"color:#fff;text-decoration:underline\">${escapeHtml(p.title)}</a>${priceHtml}${availHtml}</li>`;
      }).join('');
      addMsg('assistant', `Here's what should help:<ul>${items}</ul>`);
      if (isSoundproofing) {
        addMsg('assistant', "One honest note: these treat echo and reflections already inside a room — they won't block sound from crossing walls or floors (that needs mass/sealing, which we don't currently sell). If that's really what you need, our team can advise on WhatsApp.");
        chatWhatsappButton(text);
      }
      return;
    }

    if (isSoundproofing) {
      addMsg('assistant', "We don't currently carry true soundproofing/sound-isolation products — our panels and diffusers treat echo and reflections inside a room, not sound crossing walls or floors. Let's get you to our team so they can point you in the right direction.");
    } else {
      addMsg('assistant', "That's a bit outside what I can help with directly here — let me connect you with our team on WhatsApp, they'll sort you out quickly.");
    }
    chatWhatsappButton(text);
  }

  chatSend?.addEventListener('click', sendChat);
  chatInput?.addEventListener('keydown', (e) => { if (e.key === 'Enter') sendChat(); });

  function escapeHtml(s) {
    return s.replace(/[&<>\"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[c]));
  }
})();
